import { render } from "./Arrow.vue?vue&type=template&id=365e8156"
import script from "./Arrow.vue?vue&type=script&lang=js"
export * from "./Arrow.vue?vue&type=script&lang=js"

import "./Arrow.vue?vue&type=style&index=0&id=365e8156&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__